import PrihlaskaPlatebniInfo from "./forms/prihlaska/platebni-info.js";
import SmsCharCounter from "./forms/sms-char-counter.js";
import TinymceConfigurator from "./forms/tinymce-configurator.js";

class FormHandler {
	#availableModules = {
		platebniInfo: PrihlaskaPlatebniInfo,
		smsCharCounter: SmsCharCounter,
		tinymcev7: TinymceConfigurator
	};

	init(root = document) {
		// Vyhledá všechny formuláře s datovými atributy
		root.querySelectorAll('[data-form-modules]').forEach(el => {
			const formModules = (el.dataset.formModules || '').split(' ').filter(Boolean);
			formModules.forEach(formModuleName => {
				const formModule = this.#availableModules[formModuleName];
				if (!formModule) {
					console.warn(`Neznámý modul formuláře: ${formModule}`);
					return;
				}
				if (typeof formModule.init === 'function') {
					formModule.init(el);
				}
			});
		});
	}
}

export default new FormHandler();